import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./assets/css/sb-styles.scss";
import "./assets/images/sprite-other-icons.svg";
import { BrowserRouter, useLocation } from "react-router-dom";
import MetaTags from "./metaTags";

const AnalyticsWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_referrer: document.referrer
      });
    }
  }, [location]);

  return (
    <>
      <MetaTags />
      <App />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AnalyticsWrapper />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals((metric) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_value: metric.value,
      metric_id: metric.id,
      metric_delta: metric.delta
    });
  }
});